import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year: number;
  constructor() { }

  ngOnInit() {
    let currDate = new Date();
    this.year = currDate.getFullYear();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/footer/footer.component.ts